//@flow

import React from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import { FastField, ErrorMessage, /* getIn */  } from 'formik';
import { Label, FormGroup, Col, Row, Input } from 'reactstrap';

import NationalityDropdown from './NationalityDropdown';

const GENDER_OPTIONS = [
  { value: 'M', text: 'Male' },
  { value: 'F', text: 'Female' },
];

type Props = {
  id: string,
  name: string,
};

const Header = ({ id }: { id: string }) => (
  <FastField>
    {({
      form: {
        values: { passengerDetails },
      },
    }) => {
      return (
        <Col xs="12">
          <h3 className="title">
            Passenger {id + 1}: {passengerDetails[id].paxType}
          </h3>
        </Col>
      );
    }}
  </FastField>
);

const Passenger = ({ id, name }: Props) => (
  <Row className="pssenger-detail-wrap">
    <Header id={id} />

    <CustomField
      name={`${name}.${id}.firstName`}
      id={id}
      title="First Name"
      type="firstName"
      placeholder="Enter First Name"
    />

    <CustomField
      name={`${name}.${id}.lastName`}
      id={id}
      title="Last Name"
      type="lastName"
      placeholder="Enter last Name"
    />

    <Wrapper
      name={`${name}.${id}.nationality`}
      id={`${name}.${id}.nationality`}
    >
      <FastField name={`${name}.${id}.nationality`}>
        {({ field, form }) => {
          const { name, value } = field;
          const { setFieldValue, /* touched, errors */ } = form;
          // const isInvalid = getIn(touched, name) && getIn(errors, name);

          return (
            <React.Fragment>
              <NationalityDropdown
                id={name}
                name="nationality"
                value={value}
                setFormikState={v => setFieldValue(name, v)}
                // invalid={isInvalid}
              />
              <ErrorMessage name={name}>
                {({ error }) => <div className="error">{error}</div>}
              </ErrorMessage>
            </React.Fragment>
          );
        }}
      </FastField>
    </Wrapper>

    <CustomRadioButton
      title="Gender"
      name={`${name}.${id}.gender`}
      id={id}
      options={GENDER_OPTIONS}
      onUpdate={(setFieldValue, gender) => {
        const titleName = `${name}.${id}.title`;
        const titleValue = gender === 'M' ? 'Mr' : 'Ms';

        setFieldValue(titleName, titleValue);
      }}
    />
  </Row>
);

export default Passenger;

const Wrapper = ({ children, name }) => (
  <Col md="3">
    <FormGroup>
      {children}
      <ErrorMessage name={name}>
        {error => <div className="error">{error}</div>}
      </ErrorMessage>
    </FormGroup>
  </Col>
);

const CustomField = props => (
  <Wrapper {...props}>
    <FastField name={props.name}>
      {({ field, form }) => {
        const { name, value } = field;
        const { setFieldValue, /* touched, errors */ } = form;
        // const isInvalid = getIn(errors, name) && getIn(touched, name)

        return (
          <Input
            name={name}
            value={value}
            placeholder={props.placeholder}
            id={name}
            // invalid={isInvalid}
            onChange={e => {
              const { value } = e.target;
              const isName = name === 'firstName' || name === 'lastName';

              setFieldValue(name, value);
              if (isName) setFieldValue(`passengerDetails[0].${name}`, value);
            }}
          />
        );
      }}
    </FastField>
  </Wrapper>
);

const CustomRadioButton = ({ title, name, options, onUpdate }) => (
  <Wrapper title={title} name={name}>
    <FastField name={name} id={name}>
      {({ field, form }) => {
        const { name, value } = field;
        const { setFieldValue } = form;

        return (
          <RadioGroup
            name={name}
            selectedValue={value}
            className="row radio-fix"
            id={name}
            onChange={v => {
              setFieldValue(name, v);
              onUpdate(setFieldValue, v);
            }}
          >
            {options.map(({ value, text }) => (
              <Label className="col-6 passenger-radio" key={value}>
                <Radio value={value} className="flight" /> <span /> {text}
              </Label>
            ))}
          </RadioGroup>
        );
      }}
    </FastField>
  </Wrapper>
);

CustomRadioButton.defaultProps = {
  onUpdate: () => {},
};



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/Passenger.js